import React, { useContext } from "react"
import { ModalContext } from "src/context/ModalContext"

import ProductInfo from "./variantProductInfo"
import AddLocation from "./variantAddLocation"
import AddTiming from "./variantAddTiming"


const Modal = () => {
  const { modalData } = useContext( ModalContext )

  switch ( modalData.variant ) {
    case "service item": return <ProductInfo />
    case "mapping": return <AddLocation isDefault={ modalData.isDefault } />
    case "date & time": return <AddTiming isDefault={ modalData.isDefault } />
    default: return <></>
  }
}

export default Modal